function safeFetch(endpoint: string, options: Object = {}) {
  return fetch(endpoint, options)
    .then(res => {
      if (!res.ok) {
        throw res;
      }
      return res;
    })
    .then(res => res.json());
}

export default safeFetch;
